import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';
import { STATUS_LABEL } from '../statusLabels';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function Broadcasts() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const [targetStatus, setTargetStatus] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/broadcasts`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const send = async () => {
    if (!text.trim()) return;
    if (!window.confirm(
      targetStatus
        ? `Отправить это сообщение всем пользователям со статусом «${STATUS_LABEL[targetStatus]}»?`
        : 'Отправить это сообщение вообще всем пользователям?'
    )) return;
    setError('');
    setSending(true);
    try {
      await axios.post(`${API}/admin/broadcasts`, {
        text: text.trim(), target_status: targetStatus || null,
      }, { headers: authHeaders() });
      setText('');
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось отправить рассылку'));
    }
    setSending(false);
  };

  return (
    <Layout>
      <h1 style={ui.title}>Оповещения</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Рассылка приходит сразу — сообщением во внутренний чат приложения от имени ASTRA.
        Пользователь видит его как чат с нами, но ответить туда не может.
      </p>

      <div style={ui.card}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>Новая рассылка</div>
        <textarea
          style={{ ...ui.textarea, width: '100%', minHeight: 100, boxSizing: 'border-box', marginBottom: 12 }}
          placeholder="Текст сообщения"
          value={text}
          onChange={e => setText(e.target.value)}
        />
        <div style={ui.row}>
          <select style={ui.input} value={targetStatus} onChange={e => setTargetStatus(e.target.value)}>
            <option value="">Все пользователи</option>
            {Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>Только «{v}»</option>)}
          </select>
          <button style={ui.btn} onClick={send} disabled={sending}>{sending ? 'Отправляем…' : 'Отправить'}</button>
        </div>
        {error && <div style={ui.error}>{error}</div>}
      </div>

      <div style={ui.card}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>История рассылок</div>
        <DataTable
          rows={items}
          rowKey={b => b.id}
          emptyText="Рассылок пока не было"
          columns={[
            { key: 'text', label: 'Текст' },
            { key: 'target_status', label: 'Аудитория', render: b => b.target_status ? STATUS_LABEL[b.target_status] || b.target_status : 'Все' },
            { key: 'sent_count', label: 'Доставлено' },
            { key: 'created_at', label: 'Отправлена', render: b => fmt(b.created_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
